import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { TRequestedAppUpdateSchema } from '@/schemas/requested-app-update/requested-app-update.schema';
import { TOKEN_API_PUBLIC } from '@/utils/constant.utils';

const REQUESTED_APP_UPDATE_URI = '/requested-app-update';

export const upsertRequestedAppUpdate = async (
  requestedAppUpdate?: TRequestedAppUpdateSchema
) => {
  return requestApi({
    url: `${REQUESTED_APP_UPDATE_URI}/upsert`,
    method: HTTP_METHOD.PUT,
    body: requestedAppUpdate,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getFirstRequestedAppUpdate = async () => {
  return requestApi({
    url: `${REQUESTED_APP_UPDATE_URI}/getFirst`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};
